import React from "react";

const Title = ({ children }) => {
  return <span className="text-xl font-bold text-orange">{children}</span>;
};

export default Title;
